var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.items.length
    ? _c(
        "div",
        {
          staticClass: "lpu-medals d-flex flex-column ga-3",
          class: _setup.isMobile ? "lpu-medals--mobile" : "lpu-medals--desktop",
          attrs: { id: "medals", "data-qa": "lpu_medals" },
        },
        [
          _c(
            "h2",
            {
              staticClass: "text-subtitle-1 text--text",
              attrs: { "data-qa": "lpu_medals_title" },
            },
            [_vm._v("\n    " + _vm._s(_setup.tStatic("Медали")) + "\n  ")]
          ),
          _vm._v(" "),
          _c(_setup.CoreSwiper, {
            staticClass: "lpu-medals__swiper",
            attrs: {
              "slides-per-view": "auto",
              "space-between": 12,
              "has-pagination": false,
              "has-navigation": !_setup.isMobile,
              "free-mode": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "slides",
                  fn: function ({ slideAttrs }) {
                    return _vm._l(_setup.items, function (item, index) {
                      return _c(
                        "div",
                        _vm._b({ key: item.id }, "div", slideAttrs, false),
                        [
                          _c(_setup.LpuMedalCard, {
                            attrs: {
                              src: item.src,
                              alt: item.alt,
                              href: item.href,
                              count: item.count,
                              "use-hover": !_setup.isMobile,
                            },
                            on: {
                              open: function ($event) {
                                _setup.openedIndex = index
                              },
                            },
                          }),
                        ],
                        1
                      )
                    })
                  },
                },
              ],
              null,
              false,
              299407326
            ),
          }),
          _vm._v(" "),
          _c(_setup.LpuMedalDialog, {
            attrs: {
              value: _setup.openedIndex !== null,
              items: _setup.items,
              "initial-slide": _setup.openedIndex ?? 0,
            },
            on: { input: _setup.onDialogInput },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }